import { render, staticRenderFns } from "./BpjsKesehatanDetailForm.vue?vue&type=template&id=4f04cc41&"
import script from "./BpjsKesehatanDetailForm.vue?vue&type=script&lang=js&"
export * from "./BpjsKesehatanDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports